export function splitLines(container, openingtag, closingtag) {
  const text = container.textContent;
  container.innerHTML = '';
  for (let char of text) {
    const span = document.createElement('n');
    span.textContent = char;
    container.appendChild(span);
  }

  const spans = Array.from(container.children);
  let lines = [];
  let currentLine = [];
  let currentTop = null;

  for (let span of spans) {
    const top = span.getBoundingClientRect().top;
    if (currentTop === null) currentTop = top;

    if (Math.abs(top - currentTop) > 1) {
      lines.push(currentLine);
      currentLine = [];
      currentTop = top;
    }

    currentLine.push(span.textContent);
  }

  if (currentLine.length) {
    lines.push(currentLine);
  }

  const result = lines.map(line => openingtag + line.join('') + closingtag).join('');
  container.innerHTML = result;
}
